import { format, isToday, isYesterday, isSameYear } from 'date-fns';

export const formatRelativeTime = (date: Date | string): string => {
  const targetDate = new Date(date);
  const timeString = format(targetDate, 'h:mm a');

  if (isToday(targetDate)) {
    return `Today at ${timeString}`;
  } else if (isYesterday(targetDate)) {
    return `Yesterday at ${timeString}`;
  } else {
    const dateFormat = isSameYear(targetDate, new Date())
      ? 'MMM d'
      : 'MMM d, yyyy';
    const dateString = format(targetDate, dateFormat);
    return `${dateString} at ${timeString}`;
  }
};
